var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notice-icon",on:{"click":_vm.showInformList}},[_c('Badge',{attrs:{"dot":""}},[_c('Icon',{attrs:{"type":"ios-notifications-outline","size":"26"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }